<div class="flex items-center min-h-screen bg-blue-50 hero hero{{hero}}">
   <div class="mx-auto shadow-xl rounded-lg w-96 p-16 pb-6 bg-white box">
      <h1 class="font-semibold text-xl text-center">Bienvenido al Virtual PoS!</h1>
      <div class="w-max mx-auto mt-8">
         <working color="black" [size]="50"></working>
      </div>
      <img class="w-24 mx-auto pt-10" src="assets/logo_transneg.png">
   </div>
</div>